import { render } from "./technologyApplication.vue?vue&type=template&id=6ed4cb2a&scoped=true"
import script from "./technologyApplication.vue?vue&type=script&lang=js"
export * from "./technologyApplication.vue?vue&type=script&lang=js"

import "./technologyApplication.vue?vue&type=style&index=0&id=6ed4cb2a&scoped=true&lang=scss"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed4cb2a"]])

export default __exports__